import { render, staticRenderFns } from "./PanelDrawer.vue?vue&type=template&id=485fde14&scoped=true&"
import script from "./PanelDrawer.vue?vue&type=script&lang=js&"
export * from "./PanelDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PanelDrawer.vue?vue&type=style&index=0&id=485fde14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fde14",
  null
  
)

export default component.exports